import type { ApprovalEntry } from '@tailorcast/shared-types';
import { DiffViewer } from './DiffViewer';
import { ApprovalActions } from './ApprovalActions';

interface ApprovalCardProps {
  approval: ApprovalEntry;
}

export function ApprovalCard({ approval }: ApprovalCardProps) {
  return (
    <div className="card p-4 space-y-3">
      <div className="flex items-start justify-between">
        <div>
          <span className="text-xs px-2 py-0.5 rounded bg-yellow-100 text-yellow-800 font-medium capitalize">
            {approval.approvalType}
          </span>
          <p className="text-sm font-medium text-gray-900 mt-1">{approval.summary}</p>
        </div>
        <span className="text-xs text-gray-400">
          {new Date(approval.createdAt).toLocaleString()}
        </span>
      </div>

      {approval.diffData && <DiffViewer fieldDiffs={approval.diffData.fieldDiffs} />}

      {approval.status === 'pending' && <ApprovalActions approvalId={approval.id} />}

      {approval.status !== 'pending' && (
        <div className="text-sm text-gray-500 capitalize">Status: {approval.status}</div>
      )}
    </div>
  );
}
